import { render, staticRenderFns } from "./salaryCalculation.vue?vue&type=template&id=0949b3b2&scoped=true&"
import script from "./salaryCalculation.vue?vue&type=script&lang=js&"
export * from "./salaryCalculation.vue?vue&type=script&lang=js&"
import style0 from "./salaryCalculation.vue?vue&type=style&index=0&id=0949b3b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0949b3b2",
  null
  
)

export default component.exports